import { createRoot } from 'react-dom/client';

import { initMonitoring } from '@/utils/monitoring';

import App from './App';

initMonitoring();

createRoot(document.getElementById('root')!).render(
    // <StrictMode>
    <App />
    // </StrictMode>
);
